import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';

const TableBody = ({
    serialNumber,
    id,
    pkMemo,
    dt,
    totqty,
    sts,
    locNm,
    totamt,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/packing-edit/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };
    const userId = '1';



    const handleDeleteClick = () => {
        // Show confirmation dialog


        const isConfirmed = window.confirm("Are you sure you want to delete this Stock?");

        // // If user confirms, proceed with deletion
        if (isConfirmed) {
            // dispatch(deleteStockProduction(postData))
            //     .then(() => {
            //         // Reload the page to show updated results
            //         toast("Stock Deleted");
            //         window.location.reload();
            //     })
            //     .catch((error) => {
            //         // Handle any errors that occur during the deletion process
            //         console.error("Error deleting Item:", error);
            //         toast.error("Failed to delete Item");
            //     });
        }
    };

    const handleFinalPrint = () => {
        window.open(`/shifting-print/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    }

    const handleViewClick = () => {
        window.open(`/shifting-print/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };

    const handlePendingClick = () => {
        window.open(`/packing-sale-invoice/${id}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
    };


    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {pkMemo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {locNm}
                </TableCell>

                  <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {totqty}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {totamt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <h4 onClick={handleFinalPrint} style={{ color: '#4d79ff', cursor: 'pointer' }}>Print</h4>
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>
                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {sts === '1' ? <h4 style={{ color: 'blue' }}>Invoice Generated</h4> : <h4 style={{ color: '#ff0000', cursor: 'pointer' }} onClick={handlePendingClick}>Pending</h4>}
                </TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={`cursor-pointer`} onClick={handleDeleteClick} />
                </TableCell> */}


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
